export var InputMode;
(function (InputMode) {
    InputMode[InputMode["Date"] = 0] = "Date";
    InputMode[InputMode["Time"] = 1] = "Time";
})(InputMode || (InputMode = {}));
